import styled from '@mint-lib/styled';

import Box from '../Box/Box.jsx';

export const StyledFilterChip = styled(Box)(({ theme }) => ({
  borderRadius: '0.375rem',
  display: 'flex',
  boxSizing: 'border-box',
  backgroundColor: theme.palette.ui.selected,
  height: '1.5rem',
  maxWidth: '25rem',
  width: 'min-content',
  cursor: 'pointer',
  border: 'none',
}));

export const TextContainer = styled(Box, {
  shouldForwardProp: (prop) =>
    prop !== 'selected' &&
    prop !== 'deletable' &&
    prop !== 'truncatedChipValue',
})<{
  selected: boolean;
  deletable: boolean;
  truncatedChipValue: boolean;
}>(({ theme, selected, deletable, truncatedChipValue }) => ({
  display: 'flex',
  maxWidth: truncatedChipValue && deletable ? 'calc(100% - 21px)' : 'inherit',
  padding: deletable ? '0.25rem 0.125rem 0.25rem 0.375rem' : '0.25rem 0.375rem',
  alignItems: 'center',
  borderRadius: deletable ? '0.375rem 0rem 0rem 0.375rem' : '0.375rem',
  gap: '0.1875rem',
  backgroundColor: selected
    ? theme.palette.ui.selected
    : theme.palette.transparent.main,
  '&:hover': {
    backgroundColor: theme.palette.ui.selected,
  },
}));

export const IconContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: '0.25rem 0.1875rem',
  borderRadius: '0rem 0.375rem 0.375rem 0rem',
  '&:hover': {
    backgroundColor: theme.palette.ui.selected,
  },
}));
